// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreMcpFeedback = (client) => ({
    /**
     * `POST /store/mcp-feedback`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCreateMcpFeedback
     * @source apps/backend/src/api/store/mcp-feedback/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/mcp-feedback", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=mcp-feedback.js.map